import PropTypes from 'prop-types';

import styles from './RoundButtonWithIcon.module.scss';

const RoundButtonWithIcon = ({
  onClick,
  backgroundColor,
  text = '',
  children
}) => {
  const buttonBackground = { backgroundColor: `${backgroundColor}` };

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={styles.button}
        style={buttonBackground}
        onClick={onClick}
      >
        <span>{children}</span>
      </button>
      <span className={styles.text}>{text}</span>
    </div>
  );
};

RoundButtonWithIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  text: PropTypes.string,
  children: PropTypes.element.isRequired
};

export default RoundButtonWithIcon;
